import { IconChevronRightSmall16 } from '@cian/ui-kit';

import { clsx } from 'clsx';
import { FC, Fragment } from 'react';

import { stopPropagation } from 'shared/utils/event/stopPropagation';

import { Link } from '../InteractiveTypography';

import { AreaPartsProps } from './types';

import styles from './AreaParts.css';

export const AreaParts: FC<AreaPartsProps> = props => {
  const { subareas, more, onMoreClick, trackMoreClick, isMapOpen, trackAreaPartClick } = props;
  const mapStyles = isMapOpen && styles['map-visible'];

  return (
    <div className={styles['container']}>
      <div className={clsx(styles['area-parts-list'], mapStyles)}>
        {subareas.map(areaPart => {
          return (
            <Fragment key={areaPart.id}>
              <span className={styles['cell-floor']}>{areaPart.floor}</span>
              <span className={styles['cell-office-type']}>{areaPart.offerType}</span>
              <Link
                behaviour="hover_primary_to_primary_hover"
                display="inline"
                href={areaPart.url}
                track={trackAreaPartClick}
                onClick={stopPropagation}
              >
                {areaPart.area}
              </Link>
              <span className={styles['cell-price']}>{areaPart.price}</span>
            </Fragment>
          );
        })}
      </div>
      {!!more && (
        <div>
          <Link
            behaviour="hover_primary_to_primary_hover"
            href={more.link}
            track={trackMoreClick}
            onClick={onMoreClick}
          >
            <div className={styles['link-title']}>{more.title}</div>
            <IconChevronRightSmall16 color="current_color" />
          </Link>
        </div>
      )}
    </div>
  );
};
